import "bootstrap";
import 'bootstrap/dist/css/bootstrap.css' // Import precompiled Bootstrap css
import '@fortawesome/fontawesome-free/css/all.css'
import './css/site.css';

import { createRouter, createWebHashHistory } from 'vue-router';
import Login from './components/Login.vue';
import Settings from './components/settings/Settings.vue';

import Tables from './components/tables/Tables.vue';
import Batches from './components/batches/Batches.vue';

import GroupAdd from './components/settings/groups/GroupAdd.vue';
import GroupDetail from './components/settings/groups/GroupDetail.vue';
import GroupList from './components/settings/groups/GroupList.vue';

import UserAdd from './components/settings/users/UserAdd.vue';
import UserDetail from './components/settings/users/UserDetail.vue';
import UserList from './components/settings/users/UserList.vue';

import AuthorizationApi from "./api/server/authorization";

import DataSpace from "./components/dataspace/DataSpace.vue";
import DataSpaceLayout from "./components/dataspace/DataSpaceLayout.vue";


import DataSpaceList from "./components/settings/dataspaces/DataSpaceList.vue";
import DataSpaceAdd from "./components/settings/dataspaces/DataSpaceAdd.vue";
import DataSpaceDetail from "./components/settings/dataspaces/DataSpaceDetail.vue";

import DataBatchDetail from './components/batches/DataBatchDetail.vue';

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/dataspaces',
        name: 'DataSpaces',
        component: DataSpace
    },
    {
        path: '/dataspace/:id',
        component: DataSpaceLayout,
        props: true,
        children: [
            {
                path: '',
                name: 'dataspace',
                redirect: to => `/dataspace/${to.params.id}/tables`
            },
            {
                path: 'tables',
                name: 'tables',
                component: Tables
            },
            {
                path: 'batches',
                name: 'batches',
                component: Batches
            },
            {
                path: 'batches/:batchId',
                name: 'batchDetail',
                component: DataBatchDetail
            }
        ]
    },
    
    //ADMIN - SETTINGS
    {
        path: '/dataspaceadd',
        name: 'dataspaceadd',
        component: DataSpaceAdd
    },
    {
        path: '/dataspacedetail/:id',
        name: 'dataspacedetail',
        component: DataSpaceDetail,
        props: true
    },
    {
        path: '/groupadd',
        name: 'groupadd',
        component: GroupAdd
    },
    {
        path: '/groupdetail/:id',
        name: 'groupdetail',
        component: GroupDetail,
        props: true
    },
    {
        path: '/userdetail/:id',
        name: 'userdetail',
        component: UserDetail,
        props: true
    },
    {
        path: '/useradd',
        name: 'useradd',
        component: UserAdd
    },
    {
        path: '/settings',
        name: "settings",
        component: Settings,
        props: true,
        children: [
            {
                path: 'users',
                name: "users",
                component: UserList
            },
            {
                path: 'groups',
                name: "groups",
                component: GroupList
            },
            {
                path: 'dataspaces',
                name: "dataspaces",
                component: DataSpaceList
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    var auth = await AuthorizationApi.auth();
    if (to.name !== 'Login' && !auth.isAuthenticated) {
        next({
            name: 'Login',
            query: { returnUrl: to.fullPath }
        });
    } else {
        next();
    }
});

if (!window.indexedDB) {
    console.log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
}

export default router;